import store from '../store';
import { START_LOADING } from '../actions/types';

export default config => {
    config.apiConfig.trackLoading && store.dispatch({ type: START_LOADING, payload: config.url });

    return config;
};